var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MapModal',{attrs:{"modalNode":_vm.modalNode,"submitData":_vm.submitData,"submit":_vm.submit,"close":_vm.close,"title":_vm.roamingTitle,"id":"roamingAdit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }